var exports = {
  "K": "d-contents__KzrRnz",
};

module.exports = exports;
